import type { StepStatus } from '../types';

/**
 * Should a step render its "Preview" footer at all? True while a run is in flight — so the spinner
 * shows on the FIRST run, before any result exists — and whenever there is a result to show. Callers
 * still guard their `children` on `result != null`: JSX children evaluate eagerly, so a loading footer
 * with no result yet must not reach into it.
 */
export function hasStepPreview(status: StepStatus, result: unknown): boolean {
  return status === 'loading' || result != null;
}
